<template>
  <Teleport to="body">
    <div v-if="visible" class="ui-dismiss-layer" :style="{ zIndex: String(zIndex) }" aria-hidden="true"
      @pointerdown.stop @click.stop="emit('dismiss')"></div>
  </Teleport>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  visible: boolean;
  zIndex?: number;
}>(), {
  zIndex: 1000
});

const emit = defineEmits<{
  dismiss: [];
}>();
</script>
